module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-down-0accf0aa3b64c2e31b0a4038eb622c5f.svg";